import * as React from 'react';
import { LocalDataAutoComplete } from '../utility/LocalDataAutoComplete';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id          : string;
    label       : string;
    value       : any;
    onChange    : any;
    className?  : string;
    error?      : string;
    disable?    : boolean;
}

// #endregion

const CountryInput : React.SFC<IProps> = (props) => {

    const { className, id, error, label, value, onChange, disable } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <LocalDataAutoComplete
                id={ id }
                classList={ error ? 'error-outline' : '' }
                dataSource='countries'
                onSelectedCallback={ onChange }
                currentValue={ value ? (value.name ? value.name : value) : '' }
                disabled={ disable ? disable : false }
                placeholder="Type In a Country"
            />           
            <InputFeedback error={error} />
        </div>
    );
};

CountryInput.defaultProps = {
    className: '',
    error: '',
    disable: false
};

export { CountryInput };
